export function recipeTotals(ingredients) {
  if (!ingredients?.length) throw new Error('Añade al menos un ingrediente.');
  return ingredients.reduce((sum, item) => {
    if (!item.name?.trim() || !['grams','prot','carbs','fat'].every(k => item[k] !== '' && Number.isFinite(Number(item[k])) && Number(item[k]) >= 0) || Number(item.grams) <= 0) throw new Error('Completa los ingredientes, sus gramos y nutrientes por 100 g.');
    for (const key of ['prot','carbs','fat']) sum[key] += Number(item[key]) * Number(item.grams) / 100;
    sum.cal = sum.prot * 4 + sum.carbs * 4 + sum.fat * 9;
    return sum;
  }, {cal:0,prot:0,carbs:0,fat:0});
}
export function recipePortion(ingredients, cookedGrams, amount, unit) {
  const total = recipeTotals(ingredients);
  const weight = Number(cookedGrams), value = Number(amount);
  if (!Number.isFinite(value) || value <= 0 || !['g','%'].includes(unit)) throw new Error('Introduce una ración válida.');
  if (unit === 'g' && (!Number.isFinite(weight) || weight <= 0)) throw new Error('Indica el peso total después de cocinar.');
  const ratio = unit === '%' ? value / 100 : value / weight;
  if (ratio > 1) throw new Error('La ración no puede superar el total cocinado.');
  return Object.fromEntries(Object.entries(total).map(([k,v]) => [k, Math.round(v * ratio * 10) / 10]));
}
